import Dashboard from '../views/Dashboard'

export const dashboardRouters = {
  path: 'dashboard',
  name: 'dashboard',
  component: Dashboard,
  meta: {
    groups: 'dashboard'
  }
}
